<template>
  <DialogFactory :value="value" v-on="$listeners">
    <AbstractModalHeader :title="headingText">
      <template #close>
        <CloseIconButton @click="emitCloseEvent" />
      </template>
    </AbstractModalHeader>
    <v-card-text class="pb-0">
      <slot />
    </v-card-text>
  </DialogFactory>
</template>

<script>
import DialogFactory from '@/component/Dialog/dialog-factory';
import AbstractModalHeader from '@/component/Dialog/abstract-modal-header';
import CloseIconButton from '@/component/Button/close-icon-button';

export default {
  name: 'ServiceDetailsModal',
  components: {
    DialogFactory,
    AbstractModalHeader,
    CloseIconButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    headingText: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped></style>
